import { createReducer } from '../../utils/redux';
import * as types from './types';
import * as authTypes from '../authenticate/types';

const initialState = {
  loading: false,
  statusText: null,
  status: null,
  profiles: [],
};

export default createReducer(initialState, {
  [types.PROFILE_REQUEST]: state => (
    Object.assign({}, state, {
      loading: true,
    })
  ),
  [types.PROFILE_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      loading: false,
      status: payload.status,
      statusText: null,
      profiles: payload.profiles,
    })
  ),
  [types.PROFILE_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      loading: false,
      status: payload.status,
      statusText: payload.statusText,
    })
  ),
  [types.UPDATE_PROFILE_REQUEST]: (state, payload) => (
    Object.assign({}, state, {
      loading: true,
      profile: Object.assign({}, state.profile, payload.profile),
    })
  ),
  [types.UPDATE_PROFILE_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      loading: false,
      profile: payload.profile,
      status: payload.status,
      statusText: null,
    })
  ),
  [types.UPDATE_PROFILE_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      loading: false,
      status: payload.status,
      statusText: payload.statusText,
    })
  ),
  [authTypes.AUTHENTICATE_LOGOUT_SUCCESS]: state => (
    Object.assign({}, state, {
      profile: undefined,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/redux/profile/reducers.js